import React, { useEffect, useContext, useState } from 'react';
import { Skeleton } from '@mui/material';
import config from '../../config';
import ProductService from '../../services/ProductService';
import CategoryView from './CategoryView';
import { ShopContext } from '../../contexts/ShopContext';

const styles = {
  categoriesWrapper: {
    width: '103%',
    minHeight: 38,
    display: 'flex',
    flexWrap: 'nowrap',
    overflowX: 'auto',
    overflowY: 'hidden',
    whiteSpace: 'nowrap',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    margin: '5px 0px',
  },
  skeleton: {
    minWidth: '100px',
    height: '100%',
    marginRight: 15,
    borderRadius: 30,
  },
};

const hideScrollbarStyle = `
  .categoriesWrapper::-webkit-scrollbar {
    display: none;
  }
`;

const allCategory = {
  id: 'all',
  name: 'ALL',
  selected: true,
  image: 'https://storage.googleapis.com/sanoft-eazy-cart.appspot.com/static/images/all_cateogries.svg',
};

export default function CategoryListView({ fcnSetSelectedCategory, searchKey, clearSearchKey, selectedCategory }) {
  const { shop } = useContext(ShopContext);
  const [categories, setCategories] = useState([]);
  const [categoriesShopId, setCategoriesShopId] = useState(null);
  const [loading, setLoading] = useState(true);

  const categorySelected = (category) => {
    clearSearchKey();
    fcnSetSelectedCategory(category);
    updateSelectedCategory(category);
  };

  const updateSelectedCategory = (category) => {
    const _categories = [...categories];
    _categories.forEach((c) => (c.selected = false));
    if (category) {
      _categories.find((c) => c.id === category.id).selected = true;
    }
    setCategories(_categories);
  };

  useEffect(() => {
    if (!shop || !shop.shopId) {
      setCategories([]);
      setLoading(false);
      return;
    }

    if (categoriesShopId && shop.shopId === categoriesShopId) {
      return;
    }

    const loadCategories = async () => {
      try {
        setLoading(true);
        const _categories = await ProductService.getCategories(shop);
        const shopConfig = shop?.meta || config.meta;
    
        if (shopConfig.allCategoryRequired) {
          _categories.unshift(allCategory);
        }
    
        const savedCategory = ProductService.getSelectedCategory();
    
        _categories.forEach((cat) => {
          cat.selected = savedCategory ? cat.id === savedCategory.id : false;
        });
    
        if (!savedCategory && _categories.length) {
          const category = _categories[0];
          category.selected = true;
          ProductService.setSelectedCategory(category);
          fcnSetSelectedCategory(category);
        } else if (savedCategory) {
          fcnSetSelectedCategory(savedCategory);
        }
    
        setCategories(_categories);
        setCategoriesShopId(shop.shopId);
      } catch (error) {
        console.error(error.message);
      } finally {
        setLoading(false);
      }
    };
    loadCategories();
  }, [shop, fcnSetSelectedCategory, categoriesShopId, selectedCategory]);

  useEffect(() => {
    if (!searchKey) return;
    updateSelectedCategory(null);
    //eslint-disable-next-line
  }, [searchKey]);

  return (
    <>
      <style>{hideScrollbarStyle}</style>
      <div style={styles.categoriesWrapper}>
        {loading ? (
          [...Array(10)].map((_, index) => (
            <Skeleton
              key={index}
              variant="rectangular"
              style={{ ...styles.skeleton }}
              sx={{ bgcolor: '#d1d1d1ab' }}
              animation="wave"
            />
          ))
        ) : categories.length > 0 ? (
          categories.map((category) => (
            <CategoryView key={category.id} category={category} shop={shop} categorySelected={categorySelected} />
          ))
        ) : (
          <div style={{ padding: '10px', fontWeight: 'bold', color: '#555' }}>No categories available.</div>
        )}
      </div>
    </>
  );
}
